// @flow
import BaseModel from "../base/BaseModel";

import {
  PARAMETER_SEPARATOR,
  PARAMETER_TYPES,
} from "../../constants/Constants";

import type { ModelOptions } from "../types";

/**
 * Base class for filters
 */
export default class BaseFilterModel extends BaseModel {
  _context: Object;
  _listKey: string;

  /**
   */
  constructor(
    data: Object,
    contributions: Object,
    modelOptions?: ModelOptions,
  ) {
    super(data, contributions, modelOptions);

    if (this.contributions.listKey) {
      this.listkey = this.contributions.listKey;
    }
  }

  /**
   */
  get key(): string {
    return this.data.name;
  }

  /**
   * Get the type of a filter.
   */
  get type(): string {
    return this.contributions.type
      ? this.contributions.type.replace("filter", "")
      : "string";
  }

  /**
   * Returns the parameter type, when the filter can only be used in  a POST request the type is 'bodyParameter', else 'queryParameter'.
   */
  get parameterType(): $Values<typeof PARAMETER_TYPES> {
    const parameterType = this.getContribution("parameterType");

    if (parameterType === "bodyParameter") {
      return PARAMETER_TYPES.BODY;
    }
    return PARAMETER_TYPES.QUERY;
  }

  /**
   * Inidiates if filter is multiplechoice
   */
  get isMultiple(): boolean {
    return this.getContribution("multiplechoice", false);
  }

  /**
   * Getting context data
   */
  get context(): Object {
    return this._context;
  }

  /**
   * Set context of filter
   */
  set context(context: Object) {
    this._context = context;
  }

  /**
   */
  get contextid(): string {
    return this.getContribution("contextid", "");
  }

  /**
   * Getting the context label
   */
  get contextLabel(): string {
    return this.context?.label ?? "";
  }

  /**
   * Getting key of the list these filters apply to
   */
  get listkey(): string {
    return this._listKey;
  }

  /**
   * Set key of list this filter belongs to
   */
  set listkey(key: string) {
    this._listKey = key;
  }

  /**
   * Getting the label of the filter
   */
  get label(): string {
    return this.getContribution("label", "");
  }

  /**
   * Getting the name of the filter
   */
  get name(): string {
    if (this.listkey) {
      return this.listkey + PARAMETER_SEPARATOR + this.param;
    }

    return this.param;
  }

  /**
   * Getting the param name of the filter
   */
  get param(): string {
    return this.data.param ?? this.data.name;
  }

  /**
   * Inidicates if filter is a quick search filter
   */
  isQuickSearch(): boolean {
    return this.contributions.quicksearch === true;
  }

  /**
   * Get assistant message
   */
  get assistantMessage(): string | null {
    return this.getContribution("assistant");
  }
}
